import React, { useState } from 'react';
import {
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Typography,
  Divider,
  FormGroup,
  FormControlLabel,
  Switch
} from '@mui/material';
import { GGDialog, GGDialogTitle } from './shared/StyledDialogs';

const SettingsModal = ({ 
  onSave, 
  onClose, 
  currentWidth, 
  currentHeight, 
  currentPermissions = {},
  isCreatingRoom = false,
  hasRoomId = false,
  defaultUserName = ''
}) => {
  console.log(hasRoomId, isCreatingRoom, "currentPermissions");
  const [width, setWidth] = useState(currentWidth);
  const [height, setHeight] = useState(currentHeight);
  const [userName, setUserName] = useState(defaultUserName);
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  const [addPresenter, setAddPresenter] = useState(false);
  const [permissions, setPermissions] = useState({
    allowCharacterManagement: currentPermissions.allowCharacterManagement ?? true,
    allowEnemyManagement: currentPermissions.allowEnemyManagement ?? false,
    allowPainting: currentPermissions.allowPainting ?? false,
    allowEnemyHealthView: currentPermissions.allowEnemyHealthView ?? false,
  });

  const handleSave = () => {
    setHasAttemptedSubmit(true);
    if (isCreatingRoom && !userName.trim()) {
      return;
    }

    onSave(
      parseInt(width), 
      parseInt(height),
      permissions,
      userName,
      addPresenter
    );
  };

  return (
    <GGDialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
      <GGDialogTitle>{isCreatingRoom ? 'Create Room' : 'Game Settings'}</GGDialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {isCreatingRoom && (
            <Box>
              <Divider sx={{ my: 2 }}>Your Name</Divider>
              <TextField
                label="Enter Your Name"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                fullWidth
                required
                autoFocus
                error={hasAttemptedSubmit && !userName.trim()}
                helperText={hasAttemptedSubmit && !userName.trim() ? 'Name is required' : ''}
              />
              
              <Divider sx={{ my: 2 }}>In-Person Play</Divider>
              <FormControlLabel
                control={
                  <Switch
                    checked={addPresenter}
                    onChange={(e) => setAddPresenter(e.target.checked)}
                  />
                }
                label={
                  <Box>
                    <Typography>Add Presenter</Typography>
                    <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                      Opens a presentation window for displaying the table to in-person players
                    </Typography>
                  </Box>
                }
              />
            </Box>
          )}

          {!isCreatingRoom && (
          <Box>
            <Divider sx={{ my: 2 }}>Grid Size</Divider>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                label="Width"
                type="number"
                value={width}
                onChange={(e) => setWidth(e.target.value)}
                inputProps={{ min: 1, max: 100 }}
                fullWidth
              />
              <TextField
                label="Height"
                type="number"
                value={height}
                onChange={(e) => setHeight(e.target.value)}
                inputProps={{ min: 1, max: 100 }}
                fullWidth
              />
            </Box>
          </Box>
          )}

          {(hasRoomId || isCreatingRoom) && (
            <Box>
              <Divider sx={{ my: 2 }}>Player Permissions</Divider>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch
                      checked={permissions.allowCharacterManagement}
                      onChange={(e) => setPermissions(prev => ({
                        ...prev,
                        allowCharacterManagement: e.target.checked
                      }))}
                    />
                  }
                  label={
                    <Typography>
                      Allow players to manage characters
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={permissions.allowEnemyManagement}
                      onChange={(e) => setPermissions(prev => ({
                        ...prev,
                        allowEnemyManagement: e.target.checked
                      }))}
                    />
                  }
                  label={
                    <Typography>
                      Allow players to manage enemies
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={permissions.allowPainting}
                      onChange={(e) => setPermissions(prev => ({
                        ...prev,
                        allowPainting: e.target.checked
                      }))}
                    />
                  }
                  label={
                    <Typography>
                      Allow players to paint
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={permissions.allowEnemyHealthView}
                      onChange={(e) => setPermissions(prev => ({
                        ...prev,
                        allowEnemyHealthView: e.target.checked
                      }))}
                    />
                  }
                  label={
                    <Typography>
                      Allow players to see enemy health
                    </Typography>
                  }
                />
              </FormGroup>
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={handleSave} 
          variant="outlined"
          disabled={isCreatingRoom && !userName.trim()}
        >
          {isCreatingRoom ? 'Create Room' : 'Save Changes'}
        </Button>
      </DialogActions>
    </GGDialog>
  );
};

export default SettingsModal; 